module.exports = __webpack_public_path__ + "static/media/desktopScreenshot04.774d733e.jpg";